import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import layoutComponentsDictionary from "./layout/layoutComponentsDictionary";
import logger from "js-logger";
import React from "react";
export var SettingsComponents = function (_a) {
    var layoutName = _a.layoutName, packageName = _a.packageName, moduleName = _a.moduleName, layoutType = _a.layoutType, fieldDefs = _a.fieldDefs, studioFields = _a.studioFields;
    var componentIndex = 0;
    if (layoutType) {
        var componentName = layoutType || "";
        var layoutComponentSettings = layoutComponentsDictionary.getLayoutComponent("".concat(componentName, "-settings"));
        if (layoutComponentSettings) {
            logger.debug("[LAYOUT SETTINGS] - Utilisation du composant \"".concat(layoutComponentSettings.name, "\" pour afficher le settings du type \"").concat(componentName, "\"."));
            return React.createElement(layoutComponentSettings, {
                key: "element_settings_".concat(componentIndex++),
                moduleName: moduleName,
                layoutName: layoutName,
                packageName: packageName,
                fieldDefs: fieldDefs,
                studioFields: studioFields,
            });
        }
    }
    return _jsx(_Fragment, {});
};
